export const badgeStyle = {
  'To Do': {
    bg: '#ED9929',
    _text: {
      color: '#111C2B',
      fontSize: '0.813rem'
    },
    maxW: '54px'
  },
  'In Review': {
    bg: '#545F71',
    maxW: '75px',
    _text: {
      color: '#FFF',
      fontSize: '0.813rem'
    }
  },
  'Completed': {
    bg: '#008864',
    maxW: '84px',
    _text: {
      color: '#FFF',
      fontSize: '0.813rem'
    }
  }
};
//# sourceMappingURL=StyleSheet.js.map